import { getAuth } from "firebase/auth";

// Base URL for this project's Cloud Functions (matches apiUtils.js and the
// deleteAccount call in Main.js).
const FUNCTIONS_BASE =
  "https://us-central1-one-address-53a06.cloudfunctions.net";

// Pragmatic E.164 validation: a leading "+", a country code starting 1-9, and
// 8-15 total digits. This catches obvious typos client-side; Twilio Verify is
// the authority on whether a number is actually reachable (it won't send an
// OTP to an unroutable number). If we later need per-country formatting/length
// rules, drop in `libphonenumber-js` here without touching callers.
const E164_RE = /^\+[1-9]\d{7,14}$/;

// Strips spaces, dashes, parens etc. Does NOT invent a country code - callers
// must supply a full international number (with +).
export function normalizePhone(raw) {
  if (!raw) return "";
  let s = raw.trim().replace(/[\s().-]/g, "");
  // A leading "00" is a common way to write the international prefix.
  if (s.startsWith("00")) s = "+" + s.slice(2);
  return s;
}

export function isValidPhone(raw) {
  return E164_RE.test(normalizePhone(raw));
}

async function authedPost(path, body) {
  const user = getAuth().currentUser;
  if (!user) throw new Error("You must be signed in.");
  const token = await user.getIdToken();
  const response = await fetch(`${FUNCTIONS_BASE}/${path}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  const text = await response.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { message: text };
  }
  if (!response.ok) {
    throw new Error(data.message || text || "Request failed.");
  }
  return data;
}

// Asks the backend to text a one-time code to `phoneNumber` (Twilio Verify).
export async function startPhoneVerification(phoneNumber) {
  return authedPost("startPhoneVerification", {
    phoneNumber: normalizePhone(phoneNumber),
  });
}

// Confirms the code. On success the backend stamps phoneNumber + phoneVerified
// on the user's Firestore doc, so callers just need to re-read the user doc.
export async function checkPhoneVerification(phoneNumber, code) {
  return authedPost("checkPhoneVerification", {
    phoneNumber: normalizePhone(phoneNumber),
    code: (code || "").trim(),
  });
}
